export enum LogLevel {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
}

enum ConsoleStyleCommand {
  Bright = '\x1b[1m',
  Dim = '\x1b[2m',
  Underscore = '\x1b[4m',
  Blink = '\x1b[5m',
  Reverse = '\x1b[7m',
  Hidden = '\x1b[8m',
  Reset = '\x1b[0m',
  Italic = '\x1b[3m',
}

enum ConsoleTextColor {
  Black = '\x1b[30m',
  Red = '\x1b[31m',
  Green = '\x1b[32m',
  Yellow = '\x1b[33m',
  Blue = '\x1b[34m',
  Magenta = '\x1b[35m',
  Cyan = '\x1b[36m',
  White = '\x1b[37m',
  Gray = '\x1b[90m',
}

enum ConsoleBackgroundColor {
  Black = '\x1b[40m',
  Red = '\x1b[41m',
  Green = '\x1b[42m',
  Yellow = '\x1b[43m',
  Blue = '\x1b[44m',
  Magenta = '\x1b[45m',
  Cyan = '\x1b[46m',
  White = '\x1b[47m',
  Gray = '\x1b[100m',
}

interface ConsoleStyle {
  text?: ConsoleTextColor
  background?: ConsoleBackgroundColor
  styles?: ConsoleStyleCommand[]
}

const styleConsole = (props: ConsoleStyle = {}): string => {
  return `${ConsoleStyleCommand.Reset}${props.styles?.join('') ?? ``}${props.text ?? ''}${props.background ?? ''}`
}

const consoleColors = (logLevel: LogLevel) => {
  const level: ConsoleStyle = {
    styles: [ConsoleStyleCommand.Bright],
  }
  const tag: ConsoleStyle = {
    styles: [ConsoleStyleCommand.Bright],
  }
  const main: ConsoleStyle = {}
  const additional: ConsoleStyle = {
    text: ConsoleTextColor.Gray,
    styles: [ConsoleStyleCommand.Dim, ConsoleStyleCommand.Italic],
  }

  switch (logLevel) {
    case LogLevel.DEBUG:
      level.text = ConsoleTextColor.Black
      level.background = ConsoleBackgroundColor.Gray
      main.styles = [ConsoleStyleCommand.Dim]
      tag.styles = [ConsoleStyleCommand.Dim, ConsoleStyleCommand.Bright]
      break
    case LogLevel.INFO:
      level.text = ConsoleTextColor.Black
      level.background = ConsoleBackgroundColor.White
      break
    case LogLevel.WARN:
      level.text = ConsoleTextColor.Black
      level.background = ConsoleBackgroundColor.Yellow
      break
    case LogLevel.ERROR:
      level.text = ConsoleTextColor.White
      level.background = ConsoleBackgroundColor.Red
      main.text = ConsoleTextColor.Red
      tag.text = ConsoleTextColor.Red
      break
  }

  return {
    level,
    tag,
    main,
    additional,
  }
}

export const formatConsoleMessage = (
  tag: string,
  level: LogLevel,
  message: string,
  error: unknown | null,
  args: Record<string, unknown>,
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errorMessage = (error as any)?.message
  if (errorMessage) {
    args.error = errorMessage
  }

  const styles = consoleColors(level)

  const logParts = [
    styleConsole(styles.level),
    `\b\b\b\b\b\b ${level} `,
    styleConsole(styles.tag),
    ` ${tag}: `,
    styleConsole(styles.main),
    `${message}`,
  ]
  if (Object.keys(args).length > 0) {
    logParts.push(styleConsole(styles.additional))
    logParts.push(` ${JSON.stringify(args, null, 2)}`)
  }
  logParts.push(styleConsole())

  return logParts.join('')
}
